import { render, staticRenderFns } from "./group-bargaining-preview-dialog.vue?vue&type=template&id=4a79e04b&scoped=true"
import script from "./group-bargaining-preview-dialog.vue?vue&type=script&lang=js"
export * from "./group-bargaining-preview-dialog.vue?vue&type=script&lang=js"
import style0 from "./group-bargaining-preview-dialog.vue?vue&type=style&index=0&id=4a79e04b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a79e04b",
  null
  
)

export default component.exports